import React from "react";
import "./PartnerStatusUpdate.scss";

import { useTranslation } from "react-i18next";

import Wrapper from "../../../componentsAdditional/Wrapper";
import PartnerStatusHeader from "../../../componentsPartnerStatus/PartnerStatusHeader/PartnerStatusHeader";
import PartnerStatusDetails from "../../../componentsPartnerStatus/PartnerStatusDetails/PartnerStatusDetails";

const PartnerStatusUpdate = () => {
  const { t } = useTranslation();

  return (
    <Wrapper documentTitle={t("share.Shipment tracking")}>
      <PartnerStatusHeader />
      <main>
        <section id='PartnerStatusUpdate'>
          <div className='wrapper'>
            <PartnerStatusDetails />
          </div>
        </section>
      </main>
    </Wrapper>
  );
};

export default PartnerStatusUpdate;
